<template>
	<div class="chat-setting-switch" :aria-busy="pending ? 'true' : 'false'"
		@click.capture="preventBlockedChange" @keydown.capture="preventBlockedChange">
		<i class="setting-pending el-icon-loading" :class="{ 'is-visible': pending }"></i>
		<el-switch :value="value" :disabled="disabled || pending" @change="onChange"></el-switch>
	</div>
</template>

<script>
export default {
	name: 'ChatSettingSwitch',
	props: {
		value: {
			type: Boolean,
			required: true
		},
		pending: {
			type: Boolean,
			default: false
		},
		blocked: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		preventBlockedChange(event) {
			const isActivation = event.type === 'click' || event.key === 'Enter' || event.key === ' ';
			if (isActivation && this.blocked && !this.pending && !this.disabled) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
		onChange(value) {
			if (!this.blocked && !this.pending && !this.disabled) {
				this.$emit('input', value);
				this.$emit('change', value);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-setting-switch {
	display: grid;
	grid-template-columns: 16px 40px;
	align-items: center;
	gap: 7px;
	width: 63px;
	flex: 0 0 63px;

	.setting-pending {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		color: var(--im-color-primary);
		font-size: 13px;
		visibility: hidden;

		&.is-visible {
			visibility: visible;
		}
	}
}
</style>
